import { fg } from '@atlassian/jira-feature-gating';

export const csmNativeAssetsFieldCustomerCtxFastFollowsRelayprovider = {
	get(): boolean {
		return fg('csm_native_assets_field_customer_ctx_fast_follows');
	},
};

export default csmNativeAssetsFieldCustomerCtxFastFollowsRelayprovider;
